import {
  Collapse as ChakraCollapse,
  CollapseProps as ChakraCollapseProps,
} from '@chakra-ui/react';

// @doc https://chakra-ui.com/docs/components/transitions/usage#collapse-transition
export type CollapseProps = ChakraCollapseProps;
export const Collapse = ChakraCollapse;
